<template>
  <StudentDiscountCTA
    v-if="discountType === 'student'"
    v-bind="attrs"
    @click="() => trackClick(tracking)"
  >
    <slot></slot>
  </StudentDiscountCTA>

  <MilitaryDiscountCTA
    v-if="discountType === 'military'"
    v-bind="attrs"
    @click="() => trackClick(tracking)"
  >
    <slot></slot>
  </MilitaryDiscountCTA>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import type { ContentBlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import MilitaryDiscountCTA from '~/scopes/discount/components/MilitaryDiscountCTA/MilitaryDiscountCTA.vue'
import StudentDiscountCTA from '~/scopes/discount/components/StudentDiscountCTA/StudentDiscountCTA.vue'

defineProps<{
  discountType: 'military' | 'student'
  tracking: Required<ContentBlockProps>['tracking']
}>()

/**
 * note: attributes are not automatically inherited when there are multiple root notes.
 * this allows the parent DiscountBanner to pass attributes (such as class) to these components
 * see https://vuejs.org/api/component-instance.html#attrs
 */
const attrs = useAttrs()

const { trackClick } = useTracking()
</script>
